import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from '@angular/router';

import { NavigationService } from '../navigation/navigation.service';
import { RoutePaths } from '../navigation/route-paths';

@Injectable()
export class AccessGuard implements CanActivate {
  constructor(
    private navigationService: NavigationService,
    private router: Router
  ) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    router: RouterStateSnapshot
  ): Observable<boolean> {
    const routes = router.url.split('/');
    routes.shift();
    const [firstLevel, secondLevel] = routes;
    if (firstLevel) {
      return this.navigationService.getNavigationMenu().pipe(
        map(data => {
          const parentRoute = data.find(
            mainRoute => mainRoute.path === firstLevel
          );
          if (!parentRoute) {
            this.router.navigate([RoutePaths.NOT_FOUND]);
            return false;
          }

          if (firstLevel === RoutePaths.FINANCIAL_SERVICES) {
            return true;
          }

          if (secondLevel) {
            const child = parentRoute.children
              ? parentRoute.children.find(
                  childRoute => childRoute.path === secondLevel
                )
              : undefined;
            if (child) {
              return true;
            }
            this.router.navigate([parentRoute.path]);
            return false;
          }
          return true;
        })
      );
    }
  }
}
